module.exports = "/assets/data/491504e425ac69770823c5f90a4a9fc8-NE49.data.json";